import $ from 'jquery';
import "utils/mtiFontTrackingCode";
import { Navigation } from "../components/Navigation";
import { AudienceSessionRestoreDetection } from "../components/AudienceSessionRestoreDetection";
import { show as showSelector } from "../components/AudienceSelector";
import { SessionLoggedOutDetection } from "../components/SessionLoggedOutDetection";


//Audience selector restoration detection
AudienceSessionRestoreDetection.initDefault();

//Session logged out detection
SessionLoggedOutDetection.initDefault();

//Startup navigation
Navigation.initDefault();


//Show audience selector from audince banner click
const selectorTrigger = document.getElementById('arChangeAudience');
const audienceMismatchChangeButton = document.getElementById('arAudienceMismatchChangeButton');

var selectorTriggers = [selectorTrigger, audienceMismatchChangeButton];

for (var trigger in selectorTriggers) {
    if (selectorTriggers[trigger]) {
        selectorTriggers[trigger].addEventListener('click', () => {
            showSelector();
        });
    }
}

//Clear default value for input with autocomplete-off
$('[autocomplete=off]').each(function (key, element){
    $(element).val('');
});


const setAudienceSelectorData = (e) => {
    showSelector();
    let target = e.currentTarget;

    //Could probably set the audience selector to return a promise after 'opening'
    //I'll do it later maybe
    setTimeout(() => {
        if (target.classList.contains('ar-audience-enforced-link')) {
            document.querySelector('#targetUrl').setAttribute('value', target.href);
        } else {
            document.querySelector('#moduleId').setAttribute('value', target.dataset.moduleid);
        }
    }, 200);

    e.preventDefault();
}

$('body').on('click', '.ar-hybrid-link[data-moduleid], .ar-audience-enforced-link', setAudienceSelectorData);

$(document).on("click", ".choose-account-type", function() {
    $(".ar-account-list-type").toggleClass("show");
});

$(document).on("click", ".show-more-rte-btn", function() {
    if($(this).closest('.show-more-rte-less').hasClass("hide-rte")) {
        $(this).closest('.show-more-rte-less').removeClass("hide-rte");
        $(this).text("Show less");
    } else {
        $(this).closest('.show-more-rte-less').addClass("hide-rte");
        $(this).text("Show more");
    }
});